export default __webpack_public_path__ + "static/QR_left-107513c420438dca277172525359fa5f.svg";